import { CHAT_TITLE_MAX_LENGTH, CHAT_TITLE_SINGLE_LINE_PATTERN } from '@shared';
import { NEW_CHAT_TITLE_DEFAULT } from '../../chats.constants';
import { ChatNavigationItem } from '../../chats.interfaces';

// The chat-title contract is single-sourced in libs/shared.
// The UI checks length separately (maxlength attr + the guard below), so it
// uses the length-agnostic single-line pattern.
export { CHAT_TITLE_MAX_LENGTH };
export const CHAT_TITLE_PATTERN = CHAT_TITLE_SINGLE_LINE_PATTERN;

export interface ChatRenameCommit {
  previousTitle: string;
  title: string;
}

export function getChatRenameCommit(
  chat: ChatNavigationItem,
  displayedTitle: string,
  rawValue: string,
): ChatRenameCommit | null {
  const title = rawValue.trim();

  if (
    !title ||
    title === displayedTitle ||
    // The API DTO rejects the sentinel via @NotEquals(NEW_CHAT_TITLE_DEFAULT);
    // mirror it here so the optimistic update never has to revert on a 400.
    title === NEW_CHAT_TITLE_DEFAULT ||
    title.length > CHAT_TITLE_MAX_LENGTH ||
    !CHAT_TITLE_PATTERN.test(title)
  ) {
    return null;
  }

  return {
    title,
    previousTitle: chat.title,
  };
}
